import React from "react";
import { useDispatch } from "react-redux";
import { resetState as resetMissionState } from "./redux";
import { upsertMissionApi } from "./redux/api";
import { UpsertMissionSidebarProps } from "./types";
import { CreateMissionStepsSidebar } from "./sidebars";
import { resetState as resetOrderFormState } from "@src/features/order/pages/upsert-order-page/redux";

const resetCreateMissionWizardState = (dispatch: ReturnType<typeof useDispatch>) => {
  dispatch(resetMissionState());
  dispatch(resetOrderFormState());
  dispatch(upsertMissionApi.util.resetApiState());
};

// Both create and edit (update-mission) use the single-page Flight Plan sidebar. Reset the
// wizard state on mount/unmount so each entry starts clean before prefilling.
const UpsertMissionSidebar: React.FC<UpsertMissionSidebarProps> = () => {
  const dispatch = useDispatch();

  React.useLayoutEffect(() => {
    resetCreateMissionWizardState(dispatch);

    return () => {
      resetCreateMissionWizardState(dispatch);
    };
  }, [dispatch]);

  return <CreateMissionStepsSidebar />;
};

export default UpsertMissionSidebar;